// Auth
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

export const LOGIN_ERROR_UNAUTHORIZED = 'LOGIN_ERROR_UNAUTHORIZED'
export const LOGIN_ERROR_INVALID_REQUEST = 'LOGIN_ERROR_INVALID_REQUEST'
export const LOGIN_ERROR_NETWORK = 'LOGIN_ERROR_NETWORK'
export const LOGIN_ERROR_SERVER = 'LOGIN_ERROR_SERVER'
export const LOGIN_ERROR_UNHANDLED = 'LOGIN_ERROR_UNHANDLED'

const buildAction = function (type, resourceName) {
    return {
        REQUEST: `${type}_${resourceName}_REQUEST`,
        SUCCESS: `${type}_${resourceName}_SUCCESS`,
        ERROR: `${type}_${resourceName}_ERROR`
    }
}

const Types = {
    CREATE: 'CREATE',
    GET: 'GET',
    VIEW: 'VIEW',
    EDIT: 'EDIT'
}

const Resources = {
    PROJECT: 'PROJECT'
}


export const ProjectActions = {
    CREATE: buildAction(Types.CREATE, Resources.PROJECT),

    GET: buildAction(Types.GET, Resources.PROJECT),

    VIEW: buildAction(Types.VIEW, Resources.PROJECT),

    EDIT: buildAction(Types.EDIT, Resources.PROJECT)
}

export const GET_METAS_REQUEST = 'GET_METAS_REQUEST'
export const GET_METAS_SUCCESS = 'GET_METAS_SUCCESS'

export const CREATE_META_REQUEST = 'CREATE_META_REQUEST'
export const CREATE_META_SUCCESS = 'CREATE_META_SUCCESS'
export const CREATE_META_FAILURE = 'CREATE_META_FAILURE'

export const DELETE_META_REQUEST = 'DELETE_META_REQUEST'
export const DELETE_META_SUCCESS = 'DELETE_META_SUCCESS'
export const DELETE_META_FAILURE = 'DELETE_META_FAILURE'

export const EDIT_META_REQUEST = 'EDIT_META_REQUEST'
export const EDIT_META_SUCCESS = 'EDIT_META_SUCCESS'
export const EDIT_META_FAILURE = 'EDIT_META_FAILURE'
